import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  lockIcon: `LockIcon`
};

export function useEditFieldStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      lockIcon: [
        classNames.lockIcon,
        {
          "& .ms-Icon": { fontSize: `12px` },
          selectors: {
            ":hover": {
              cursor: `auto`,
              color: semanticColors.inputBorderHovered,
              backgroundColor: `none`
            },
            ":active": {
              backgroundColor: `none`
            }
          }
        }
      ]
    }),
    [semanticColors]
  );
}
